import React, { useEffect, useState } from 'react';
import styled, { createGlobalStyle } from 'styled-components';
import { useHistory } from 'react-router-dom';
import CustomImage from '../CustomImage';
import ProfilePopover from './ProfilePopover';
import menuOpen from '@src/assets/icons/icon-menu-open.svg';
import menuClose from '@src/assets/icons/icon-menu-close.svg';
import search from '@src/assets/icons/icon-mobile-search.svg';
import notification from '@src/assets/icons/icon-mobile-notification.svg';
import edenredMobilIcon from '@src/assets/icons/edenred-mobil-icon.svg';
import avatar from '@src/assets/icons/icon-mobile-account.svg';
import NotificationPopover from './NotificationPopover';
import { useSelector } from 'react-redux';
import CustomSearch, { FormatResult } from '@src/components/CustomSearch';

import { Text } from '@src/components';

const Content = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 80px;
`;

const EndContent = styled(Content)`
  width: 100%;
  justify-content: flex-end;
`;

const NumberNotify = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 13px;
  height: 13px;
  background-color: #c50e00;
  color: #fff;
  font-size: 10px;
  border-radius: 50%;
  position: absolute;
  right: 8px;
  top: -10px;
`;
const MobileSearchWrapper = styled.div`
  *::-webkit-scrollbar {
    width: 19px;
  }
  *::-webkit-scrollbar-track {
    background: #dee2e6;
  }
  ::-webkit-scrollbar-track {
    background: #dee2e6;
    margin-top: -10px
    border-radius: 100vw;
  }
  
  *::-webkit-scrollbar-thumb {
    background: #6b7789;
    border: 4.5px #dee2e6 solid;
    border-radius: 10px;
  } 
    margin-left: -24px;
    width: 100vw;
    height: 100vh;
    background-color: rgba(255,255,255, 1);
    
    div > input{
        padding-left: 44px;
    }
    
    div:has(& >#search-icon){
        height: 40px
    }
    
    #search-icon{
        margin: 13px 16px !important;
        width: 16px;
        height: 16px;
    }
    #delete-icon{
        margin: 13px 12px !important;
        width: 16px;
        height: 16px;
    }
 
    .input-wrapper{
        display:flex;
        margin:0 16px;
        padding-top:16px;
        background-color: white;
        .line{
            display: none;
        }
        ul{
            display: none;
        }
        input{
        ::placeholder {
            font-size: 12px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.67;
            letter-spacing: normal;
            color: #cbd2dd;
          }
        }
    }
    .results-wrapper{
        max-height: 500px;
        overflow-y: auto;
        background-color: rgba(255,255,255, 1);
        .heading{
            padding:16px 16px 8px 16px;
            font-family:'UbuntuBold', sans serif;
            font-size: 14px;
            line-height: 22px;
        }
        .results-wrapper-in{
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: flex-start;
            margin: 0 12px 0 16px;
            & > div{
                width: calc(100% - 12px);
            }
        
        .item{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            width: 100%;
            font-family: UbuntuMedium, sans-serif;
          font-size: 12px;
          font-weight: 300;
          font-stretch: normal;
          font-style: normal;
          line-height: 2.92;
          letter-spacing: normal;
          color: #151e57;
          .category{
              font-family: 'UbuntuMedium', sans-serif;
              font-size: 12px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 2.92;
              letter-spacing: normal;
              text-align: right;
              color: #929ca9;
          }
        }
        }
    }
`;
const BodyScrollHidden = createGlobalStyle`
    body{
        overflow: hidden;
    }
`;

const MobilHeader = ({ setCollapsed, collapsed }) => {
  const [searchText, setSearchText] = useState('');
  const [openSearchBar, setOpenSearchBar] = useState(false);
  const [isProfilePopoverVisible, setIsProfilePopoverVisible] = useState(false);
  const [isNotificationPopoverVisible, setIsNotificationPopoverVisible] = useState(false);
  const { notificationList } = useSelector((state) => state?.notifications);
  const [SearchList, setSearchList] = useState([]);
  const { isAdmin } = useSelector((state) => state?.auth);
  const history = useHistory();

  const handleOnSearch = (string, results) => {
    setSearchText(string);
    getSearchedList(results, string);
  };

  const getSearchedList = (list, text) => {
    list.map((l) => {
      l.searchText = text;
      return l;
    });
    setSearchList(list);
  };

  const onCancelFn = () => {
    setSearchList([]);
    setSearchText('');
    document.querySelector('[data-test="search-input"]')?.focus();
  };

  const handleOnSelect = (item) => {
    setOpenSearchBar(false);
    history.push(item.url);
  };

  useEffect(() => {
    onCancelFn();
  }, [openSearchBar]);

  return (
    <>
      <Content>
        <CustomImage
          alt="menu-mobil"
          src={!collapsed ? menuOpen : menuClose}
          onClick={() => setCollapsed(!collapsed)}
          style={{ cursor: 'pointer', width: '24px', objectFit: 'contain' }}
        />
        <CustomImage
          src={edenredMobilIcon}
          style={{ padding: '0 20px', cursor: 'pointer' }}
          onClick={() => history.push('/dashboard')}
        />
        <EndContent>
          <CustomImage
            src={search}
            onClick={() => setOpenSearchBar((a) => !a)}
            alt="search-mobile"
            style={{ padding: '0 17px 0 0 ', cursor: 'pointer' }}
          />
          {!isAdmin && (
            <>
              {/*
              <FastAccessPopover
              isFastAccessPopoverVisible={isFastAccessPopoverVisible}
              setIsFastAccessPopoverVisible={setIsFastAccessPopoverVisible}
              >
              <CustomImage
                src={fastAccess}
                style={{ padding: '0 18px 0 0 ', cursor: 'pointer' }}
              />
              </FastAccessPopover>
            */}
              <span style={{ position: 'relative' }}>
                <NotificationPopover
                  isNotificationPopoverVisible={isNotificationPopoverVisible}
                  setIsNotificationPopoverVisible={setIsNotificationPopoverVisible}
                  notificationList={notificationList}
                >
                  <CustomImage
                    src={notification}
                    style={{ cursor: 'pointer', padding: '0 18px 0 0' }}
                  />
                  <NumberNotify>{notificationList ? notificationList.length : 0}</NumberNotify>
                </NotificationPopover>
              </span>
            </>
          )}

          <ProfilePopover
            isProfilePopoverVisible={isProfilePopoverVisible}
            setIsProfilePopoverVisible={setIsProfilePopoverVisible}
          >
            <CustomImage
              src={avatar}
              alt="account-mobile"
              style={{ cursor: 'pointer' }}
              onClick={() => setIsProfilePopoverVisible(!isProfilePopoverVisible)}
            />
          </ProfilePopover>
        </EndContent>
      </Content>
      {openSearchBar && (
        <MobileSearchWrapper>
          <div className={'input-wrapper'}>
            <CustomSearch
              autoFocus={true}
              onSearchFn={handleOnSearch}
              onCancelFn={onCancelFn}
              styling={{
                height: '40px',
                border: 'solid 1px #c4c7d4;',
                borderRadius: '5px',
                backgroundColor: 'white',
                boxShadow: 'rgba(32, 33, 36, 0.28) 0px 1px 6px 0px',
                hoverBackgroundColor: '#eee',
                color: '#212121',
                fontSize: '16px',
                fontFamily: 'UbuntuRegular, sans-serif',
                iconColor: 'grey',
                lineColor: '#c4c7d4',
                placeholderColor: 'grey',
                clearIconMargin: '3px 14px 0 0',
                searchIconMargin: '0 0 0 16px',
              }}
            />
            <span
              style={{
                width: '51px',
                textAlign: 'right',
                marginTop: '10px',
                textDecoration: 'underline',
                fontSize: '12px',
                fontWeight: '300',
                fontStretch: 'normal',
                fontStyle: 'normal',
                lineHeight: 'normal',
                letterSpacing: 'normal',
                color: '#1d2228',
              }}
              onClick={() => setOpenSearchBar(false)}
            >
              <Text t="giveUp" />
            </span>
          </div>
          <div className={'results-wrapper'}>
            {SearchList.length > 0 && (
              <div className={'heading'}>
                <Text t="results" />
              </div>
            )}
            {SearchList.length === 0 && searchText !== '' && (
              <div className={'heading'}>
                <Text t="noResultsFound" />
              </div>
            )}
            <div className={'results-wrapper-in'}>
              {SearchList.map((l, i) => (
                <div key={l.searchText} onClick={() => handleOnSelect(l)}>
                  <FormatResult item={l} searchText={l.searchText} />
                </div>
              ))}
            </div>
          </div>
          <BodyScrollHidden />
        </MobileSearchWrapper>
      )}
    </>
  );
};

export default MobilHeader;
